import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {MatButtonModule} from "@angular/material/button";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatRadioModule} from "@angular/material/radio";
import {MatSelectModule} from "@angular/material/select";
import {MatSnackBarModule} from "@angular/material/snack-bar";

import {DecimalFormatPipe} from "../shared/pipes/decimal-format/decimal-format.pipe";
import {BASE_PATH} from "./generated-sources/api";
import {AlgorithmicDmvDialogComponent} from "./algorithmic-dmv-dialog/algorithmic-dmv-dialog.component";
import {AlgorithmicDmvStatusChipComponent} from "./algorithmic-dmv-status-chip/algorithmic-dmv-status-chip.component";
import {AlgorithmicDmvViewerPageComponent} from "./algorithmic-dmv-viewer-page/algorithmic-dmv-viewer-page.component";

@NgModule({
    declarations: [
        AlgorithmicDmvDialogComponent,
        AlgorithmicDmvStatusChipComponent,
        AlgorithmicDmvViewerPageComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatSnackBarModule,
        DecimalFormatPipe
    ],
    exports: [
        AlgorithmicDmvDialogComponent,
        AlgorithmicDmvStatusChipComponent,
        AlgorithmicDmvViewerPageComponent
    ],
    providers: [
        // The generated AlgorithmicDmvApiService defaults to "http://localhost" (no
        // port), which bypasses the dev proxy. ".." routes requests relative to the
        // SPA path (e.g. /api/...) so the proxy forwards them to the backend.
        // Mirrors the pattern in FundModule, AssetModule, etc.
        {provide: BASE_PATH, useValue: ".."}
    ]
})
export class AlgorithmicDmvModule {}
